import { query } from 'ally.js';

const queryFocusable = query.focusable;

const KEY = {
    ENTER: 'Enter',
    SPACE: ' ',
};

function focusFirstFocusableElement(
    context,
    includeContext = false,
    preventScroll = false
) {
    if (context) {
        const focusable = queryFocusable({ context, includeContext });
        if (focusable.length > 0) {
            focusable[0].focus({ preventScroll });
        }
    }
}

function handleButtonKeyDown(event, callback) {
    switch (event.key) {
        case KEY.ENTER:
        case KEY.SPACE:
            event.preventDefault();
            callback();
            break;
        default:
            break;
    }
}

function lockScroll() {
    document.body.classList.add('lock-scroll');
}

function unlockScroll() {
    document.body.classList.remove('lock-scroll');
}

export default {
    handleButtonKeyDown,
    focusFirstFocusableElement,
    lockScroll,
    unlockScroll,
};
